import {isPublic} from 'configuration';

export const isMockWorkId = (workId: string): boolean => {
  if (isPublic()) {
    // Never use mock IDs in non-local environments
    return false;
  }

  return workId === 'ca885374-40e3-475a-945e-e6d17b7bf3c3';
};
